import { useState } from "react";
import SidebarComp from "../../../components/Sidebar";
import Header from "../../../components/Header";
import "../styles/dashboard.css"
import Claim_submission from "../../Claim_Submission";


const ClaimSubmissionHome = () => {

    const [collapsed , setCollapsed] = useState(false);

    return (
      <>
        <div className="dashboard-main-cover-wrapper">
            <Header/>
            <div className="dashboard-inner-main-cover-wrapper">
              <div className="dashboard-sidebar">
                  <SidebarComp setCollapsed={setCollapsed} collapsed={collapsed}/>
              </div>
              <div className={ collapsed ? "dashboard-content-cover-closed-wrapper" : "dashboard-content-cover-wrapper"}>
                  <Claim_submission/>
              </div>
            </div>
        </div>
      </>
    );
  };
  
  export default ClaimSubmissionHome;